import React, { useState, useEffect, useReducer } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Button,
  Row,
  Col,
  Dropdown,
  Checkbox,
  List,
  Modal,
  ControlLabel,
  Input,
  SelectPicker,
  DatePicker,
  Uploader,
  Drawer,
  InputGroup,
  CheckboxGroup,
  Container,
  Whisper,
  Tooltip,
} from 'rsuite'
import { initialNewData, getExpandedId, getNewDataEdit } from './ExpenseRecordUtils'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { budgetFormat } from '../../utils/formatterUtil'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
  hasMinValidator,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import moment from 'moment/moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import { cloneDeep, isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import { getValueFromOptions } from '../../utils/dataUtil'
import { getReceivedFrom } from '../../redux/actions/incomeAndExpense'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { sessionGetItemJSON } from '../../utils/sessionHelpers'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'

export default function ExpenseRecordDurableArticlesModal({
  schema,
  showModalDurableArticles,
  setShowModalDurableArticles = () => {},
  data,
  onSubmitDurableArticles = () => {},
  onPreview = () => {},
  onDownload = () => {},
  viewMode = false,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [tableData, setTableData] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')

  const _styleCellSummary = { backgroundColor: '#1f5581', color: '#fff', fontWeight: 'bold' }
  const fs = localStorage.getItem('fontSize')
  const defaultMaxFileSize = 5

  useEffect(() => {
    if (data) {
      //setMasterTableData(schema.values)
      setTableData(data)

      register(schema?.durableArticlesAmount?.name, data.durableArticlesAmount)
      register(schema?.durableArticlesName?.name, data.durableArticlesName)
      register(schema?.durableArticlesPrice?.name, data.durableArticlesPrice)
      register(schema?.durableArticlesType?.name, data.durableArticlesType)
      register(
        schema?.durableArticlesDocumentDate?.name,
        data?.durableArticlesDocumentDate
          ? moment(schema?.durableArticlesDocumentDate, DATE_PICKER_FORMAT).toDate()
          : moment().startOf('day').toDate()
      )
      register(schema?.durableArticlesDocumentNo?.name, data.durableArticlesDocumentNo)
      register(schema?.durableArticlesAttachFiles?.name, data.durableArticlesAttachFiles)
      register(
        schema?.durableArticlesDocumentAttachFiles?.name,
        data.durableArticlesDocumentAttachFiles
      )

      setValue(schema?.durableArticlesAmount?.name, data.durableArticlesAmount)
      setValue(schema?.durableArticlesName?.name, data.durableArticlesName)
      setValue(schema?.durableArticlesPrice?.name, data.durableArticlesPrice)
      setValue(schema?.durableArticlesType?.name, data.durableArticlesType)
      setValue(
        schema?.durableArticlesDocumentDate?.name,
        data?.durableArticlesDocumentDate
          ? moment(schema?.durableArticlesDocumentDate, DATE_PICKER_FORMAT).toDate()
          : moment().startOf('day').toDate()
      )
      setValue(schema?.durableArticlesDocumentNo?.name, data.durableArticlesDocumentNo)
      data.durableArticlesAttachFiles &&
        setValue(schema?.durableArticlesAttachFiles?.name, data.durableArticlesAttachFiles)
      data.durableArticlesDocumentAttachFiles &&
        setValue(
          schema?.durableArticlesDocumentAttachFiles?.name,
          data.durableArticlesDocumentAttachFiles
        )
    }
  }, [data])

  const onSubmit = (data) => {
    console.log('submit DurableArticles data', data)
    onSubmitDurableArticles(data)
  }

  return (
    <>
      <div className="modal-container">
        <Modal
          show={showModalDurableArticles}
          onHide={() => setShowModalDurableArticles(false)}
          size={'lg'}
        >
          <Modal.Header>
            <Modal.Title>ค่าครุภัณฑ์</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: 'unset' }}>
            <Container style={{ height: '100%' }}>
              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema?.durableArticlesAmount.validators,
                      schema?.durableArticlesAmount.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema?.durableArticlesAmount.name]} />
                  <Controller
                    name={schema.durableArticlesAmount.name}
                    control={control}
                    //defaultValue={schema.durableArticlesAmount.value || ''}
                    //defaultValue={getValues(schema.durableArticlesAmount.name) || ''}
                    defaultValue={data?.durableArticlesAmount || ''}
                    rules={isValidators(schema.durableArticlesAmount.validators)}
                    render={(props) => {
                      if (viewMode) {
                        return <span>: {props.value}</span>
                      }
                      return (
                        <Input
                          placeholder={'ระบุ' + schema.durableArticlesAmount.label}
                          value={props.value}
                          maxLength={
                            getMaxLengthData(schema.durableArticlesAmount.validators).value
                          }
                          onChange={(value, e) => {
                            props.onChange(value)
                          }}
                          disabled={schema.durableArticlesAmount.disabled}
                          type="number"
                        />
                      )
                    }}
                  />
                  {/* <Input
                    name={schema?.durableArticlesAmount.name}
                    defaultValue={schema?.durableArticlesAmount.value}
                    type="number"
                    inputRef={register(isValidators(schema?.durableArticlesAmount.validators))}
                    placeholder={'ระบุ' + schema?.durableArticlesAmount.label}
                  /> */}
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema?.durableArticlesName.validators,
                      schema?.durableArticlesName.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema?.durableArticlesName.name]} />
                  <Controller
                    name={schema.durableArticlesName.name}
                    control={control}
                    //defaultValue={schema.durableArticlesName.value || ''}
                    //defaultValue={getValues(schema.durableArticlesName.name) || ''}
                    defaultValue={data?.durableArticlesName || ''}
                    rules={isValidators(schema.durableArticlesName.validators)}
                    render={(props) => {
                      if (viewMode) {
                        return <span>: {props.value}</span>
                      }
                      return (
                        <Input
                          placeholder={'ระบุ' + schema.durableArticlesName.label}
                          value={props.value}
                          maxLength={getMaxLengthData(schema.durableArticlesName.validators).value}
                          onChange={(value, e) => {
                            props.onChange(value)
                          }}
                          disabled={schema.durableArticlesName.disabled}
                        />
                      )
                    }}
                  />
                  {/* <Input
                    name={schema?.durableArticlesName.name}
                    defaultValue={schema?.durableArticlesName.value}
                    inputRef={register(isValidators(schema?.durableArticlesName.validators))}
                    placeholder={'ระบุ' + schema?.durableArticlesName.label}
                  /> */}
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema?.durableArticlesPrice.validators,
                      schema?.durableArticlesPrice.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema?.durableArticlesPrice.name]} />
                  <Controller
                    name={schema.durableArticlesPrice.name}
                    control={control}
                    //defaultValue={schema.durableArticlesPrice.value || ''}
                    //defaultValue={getValues(schema.durableArticlesPrice.name) || ''}
                    defaultValue={data?.durableArticlesPrice || ''}
                    rules={isValidators(schema.durableArticlesPrice.validators)}
                    render={(props) => {
                      if (viewMode) {
                        return <span>: {props.value}</span>
                      }
                      return (
                        <Input
                          placeholder={'ระบุ' + schema.durableArticlesPrice.label}
                          value={props.value}
                          maxLength={getMaxLengthData(schema.durableArticlesPrice.validators).value}
                          onChange={(value, e) => {
                            props.onChange(value)
                          }}
                          disabled={schema.durableArticlesPrice.disabled}
                          type="number"
                        />
                      )
                    }}
                  />
                  {/* <Input
                    name={schema?.durableArticlesPrice.name}
                    defaultValue={schema?.durableArticlesPrice.value}
                    inputRef={register(isValidators(schema?.durableArticlesPrice.validators))}
                    placeholder={'ระบุ' + schema?.durableArticlesPrice.label}
                  /> */}
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema?.durableArticlesType.validators,
                      schema?.durableArticlesType.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema?.durableArticlesType.name]} />
                  <Controller
                    name={schema?.durableArticlesType.name}
                    control={control}
                    //defaultValue={schema?.durableArticlesType.value}
                    //defaultValue={getValues(schema.durableArticlesType.name) || ''}
                    defaultValue={data?.durableArticlesType || ''}
                    rules={isValidators(schema?.durableArticlesType.validators)}
                    render={(props) => {
                      if (viewMode) {
                        return (
                          <span>
                            :{' '}
                            {getValueFromOptions(schema?.durableArticlesType.options, props.value)}
                          </span>
                        )
                      }
                      return (
                        <SelectPicker
                          searchable={false}
                          data={schema?.durableArticlesType.options}
                          value={props.value}
                          block
                          placeholder="เลือก"
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema?.durableArticlesDocumentNo.validators,
                      schema?.durableArticlesDocumentNo.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema?.durableArticlesDocumentNo.name]} />
                  <Controller
                    name={schema.durableArticlesDocumentNo.name}
                    control={control}
                    defaultValue={data?.durableArticlesDocumentNo || ''}
                    rules={isValidators(schema.durableArticlesDocumentNo.validators)}
                    render={(props) => {
                      if (viewMode) {
                        return <span>: {props.value}</span>
                      }
                      return (
                        <Input
                          placeholder={'ระบุ' + schema.durableArticlesDocumentNo.label}
                          value={props.value}
                          maxLength={
                            getMaxLengthData(schema.durableArticlesDocumentNo.validators).value
                          }
                          onChange={(value, e) => {
                            props.onChange(value)
                          }}
                          disabled={schema.durableArticlesDocumentNo.disabled}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema?.durableArticlesDocumentDate.validators,
                      schema?.durableArticlesDocumentDate.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema?.durableArticlesDocumentDate.name]} />
                  <Controller
                    key={schema?.durableArticlesDocumentDate.name}
                    name={schema?.durableArticlesDocumentDate.name}
                    control={control}
                    defaultValue={
                      data?.durableArticlesDocumentDate
                        ? moment(data?.durableArticlesDocumentDate, DATE_PICKER_FORMAT).toDate()
                        : moment().startOf('day').toDate()
                    }
                    rules={isValidators(schema?.durableArticlesDocumentDate.validators)}
                    render={(props) => {
                      console.log(props.value)
                      if (viewMode) {
                        let date = new Date(props.value).toLocaleDateString('th-TH')
                        return <span>: {date}</span>
                      }
                      return (
                        <DatePickerCustom {...props} />
                        // <DatePicker
                        //   format={DATE_PICKER_FORMAT}
                        //   locale={LOCAL_DAY_TH}
                        //   block
                        //   oneTap
                        //   value={props.value}
                        //   onChange={(value) => {
                        //     props.onChange(value)
                        //     // onChangeReportDate(value)
                        //   }}
                        // />
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema?.durableArticlesDocumentAttachFiles.validators,
                      schema?.durableArticlesDocumentAttachFiles.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema?.durableArticlesDocumentAttachFiles.name]} />
                  <Controller
                    key={schema?.durableArticlesDocumentAttachFiles.name}
                    name={schema?.durableArticlesDocumentAttachFiles.name}
                    control={control}
                    rules={isValidators(schema?.durableArticlesDocumentAttachFiles.validators)}
                    //defaultValue={''}
                    //defaultValue={getValues(schema.durableArticlesDocumentAttachFiles.name) || ''}
                    defaultValue={data?.durableArticlesDocumentAttachFiles || ''}
                    render={(props) => {
                      console.log('props', props)
                      if (props.value || viewMode) {
                        return (
                          <div
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {props?.value[0]?.name && <p>{props?.value[0]?.name}</p>}
                            <ButtonGroup>
                              <TooltipButton
                                isStart={true}
                                icon="eye"
                                tooltip={`แสดง`}
                                disabled={!(props?.value && typeof props?.value == 'string')}
                                onClick={(e) => onPreview(props?.value, 'ใบเสร็จครุภัณฑ์')}
                              ></TooltipButton>
                              <TooltipButton
                                isStart={false}
                                icon="download"
                                tooltip={`ดาวน์โหลด`}
                                disabled={!(props?.value && typeof props?.value == 'string')}
                                onClick={(e) => onDownload(props?.value, 'ใบเสร็จครุภัณฑ์')}
                              ></TooltipButton>
                              <TooltipButton
                                isStart={false}
                                icon="trash-o"
                                tooltip={`ลบ`}
                                disabled={viewMode}
                                onClick={() => props.onChange()}
                                iconStyle={{ backgroundColor: '#fb8a81' }}
                              ></TooltipButton>
                            </ButtonGroup>
                          </div>
                        )
                      } else {
                        return (
                          <Uploader
                            accept={
                              schema.durableArticlesDocumentAttachFiles.fileType ||
                              '.jpg, .jpeg, .png, .pdf'
                            }
                            autoUpload={false}
                            disabled={schema?.durableArticlesDocumentAttachFiles.disabled}
                            fileListVisible={true}
                            listType="picture-text"
                            fileList={props.value || []}
                            onChange={(fileList) => {
                              if (isEmpty(fileList)) {
                                props.onChange(undefined)
                              } else {
                                let file = fileList[fileList.length - 1]

                                if (
                                  file.blobFile.size >
                                  (schema?.durableArticlesDocumentAttachFiles?.fileSize ||
                                    defaultMaxFileSize) *
                                    1024 *
                                    1024
                                ) {
                                  notification.open('error', {
                                    title: `ขนาดไฟล์เกิน ${schema?.durableArticlesDocumentAttachFiles?.fileSize || defaultMaxFileSize} MB`,
                                    duration: 5000,
                                  })
                                  return
                                }

                                if (isImageOrPdf(file.blobFile.type)) {
                                  props.onChange(fileList)
                                  setFileTypeError(false)
                                } else {
                                  notification.open('error', {
                                    title:
                                      'ชนิดที่รองรับ ' +
                                        schema.durableArticlesDocumentAttachFiles.fileType ||
                                      '.jpg, .jpeg, .png, .pdf',
                                    duration: 5000,
                                  })
                                  setFileTypeError(true)
                                }
                              }
                            }}
                            draggable
                          >
                            <div>
                              <Icon size="2x" icon="upload2" />
                              <small className="uploder__text"></small>
                              {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                schema.durableArticlesDocumentAttachFiles.fileType ||
                                '.jpg, .jpeg, .png, .pdf'
                              } , ขนาดไฟล์ไม่เกิน ${schema.durableArticlesDocumentAttachFiles.fileSize || defaultMaxFileSize} MB`}
                            </div>
                            {/* <div style={{ lineHeight: '100px' }}>
                              <Icon size="4x" icon="upload2" />
                              <small
                                style={{
                                  marginTop: '-70px',
                                  display: 'block',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </small>
                            </div> */}
                          </Uploader>
                        )
                      }
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema?.durableArticlesAttachFiles.validators,
                      schema?.durableArticlesAttachFiles.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema?.durableArticlesAttachFiles.name]} />
                  <Controller
                    key={schema?.durableArticlesAttachFiles.name}
                    name={schema?.durableArticlesAttachFiles.name}
                    control={control}
                    rules={isValidators(schema?.durableArticlesAttachFiles.validators)}
                    //defaultValue={''}
                    //defaultValue={getValues(schema.durableArticlesAttachFiles.name) || ''}
                    defaultValue={data?.durableArticlesAttachFiles || ''}
                    render={(props) => {
                      if (props.value || viewMode) {
                        return (
                          <div
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              //whiteSpace: 'nowrap',
                            }}
                          >
                            {props?.value[0]?.name && <p>{props?.value[0]?.name}</p>}
                            <ButtonGroup>
                              <TooltipButton
                                isStart={true}
                                icon="eye"
                                tooltip={`แสดง`}
                                disabled={!(props?.value && typeof props?.value == 'string')}
                                onClick={(e) => onPreview(props?.value, 'รูปภาพประกอบครุภัณฑ์')}
                              ></TooltipButton>
                              <TooltipButton
                                isStart={false}
                                icon="download"
                                tooltip={`ดาวน์โหลด`}
                                disabled={!(props?.value && typeof props?.value == 'string')}
                                onClick={(e) => onDownload(props?.value, 'รูปภาพประกอบครุภัณฑ์')}
                              ></TooltipButton>
                              <TooltipButton
                                isStart={false}
                                icon="trash-o"
                                tooltip={`ลบ`}
                                disabled={viewMode}
                                onClick={() => props.onChange()}
                                iconStyle={{ backgroundColor: '#fb8a81' }}
                              ></TooltipButton>
                            </ButtonGroup>
                          </div>
                        )
                      } else {
                        return (
                          <Uploader
                            accept={'jpg, .jpeg, .png, .pdf'}
                            autoUpload={false}
                            disabled={schema?.durableArticlesAttachFiles.disabled}
                            fileListVisible={true}
                            listType="picture-text"
                            fileList={props.value || []}
                            onChange={(fileList) => {
                              if (isEmpty(fileList)) {
                                props.onChange(undefined)
                              } else {
                                let file = fileList[fileList.length - 1]

                                if (
                                  file.blobFile.size >
                                  (schema?.durableArticlesAttachFiles?.fileSize ||
                                    defaultMaxFileSize) *
                                    1024 *
                                    1024
                                ) {
                                  notification.open('error', {
                                    title: `ขนาดไฟล์เกิน ${schema?.durableArticlesAttachFiles?.fileSize || defaultMaxFileSize} MB`,
                                    duration: 5000,
                                  })
                                  return
                                }

                                if (isImageOrPdf(file.blobFile.type)) {
                                  props.onChange(fileList)
                                  setFileTypeError(false)
                                } else {
                                  notification.open('error', {
                                    title:
                                      'ชนิดที่รองรับ ' +
                                        schema.durableArticlesAttachFiles.fileType ||
                                      '.jpg, .jpeg, .png, .pdf',
                                    duration: 5000,
                                  })
                                  setFileTypeError(true)
                                }
                              }
                            }}
                            draggable
                          >
                            <div>
                              <Icon size="2x" icon="upload2" />
                              <small className="uploder__text"></small>
                              {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                schema.durableArticlesAttachFiles.fileType ||
                                '.jpg, .jpeg, .png, .pdf'
                              } , ขนาดไฟล์ไม่เกิน ${schema.durableArticlesAttachFiles.fileSize || defaultMaxFileSize} MB`}
                            </div>
                            {/* <div style={{ lineHeight: '100px' }}>
                              <Icon size="4x" icon="upload2" />
                              <small
                                style={{
                                  marginTop: '-70px',
                                  display: 'block',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </small>
                            </div> */}
                          </Uploader>
                        )
                      }
                    }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            {!viewMode && (
              <Button appearance="primary" onClick={handleSubmit(onSubmit)}>
                บันทึก
              </Button>
            )}
            <Button appearance="subtle" onClick={() => setShowModalDurableArticles(false)}>
              {viewMode ? 'ปิด' : 'ยกเลิก'}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
